import React from 'react'
import loading_bg001 from './static/loading_bg001.png'
import logo from './static/logo.png'

import index_bg2 from  './static/Home_page_bg02.png'

import main_01 from  './static/main_01.png'
import main_02 from  './static/main_02.png'
import main_03 from  './static/main_03.png'
import main_04 from  './static/main_04.png'
import main_05 from  './static/main_05.png'
import main_06 from  './static/main_06.png'
import main_07 from  './static/main_07.png'

import person1 from  './static/01anjianyuan.png'
import person2 from  './static/02zhanwuyuan.png'
import person3 from  './static/03liechesiji.png'
import person4 from  './static/04baojieyuan.png'
import person5 from  './static/05cheliangjianxiugong.png'
import person6 from  './static/06jiechuwanggong.png'
import person7 from  './static/07AFCjianxiugong.png'
import person8 from  './static/08diaoduzhongxinpiaowu.png'
import person9 from  './static/09tonghaojianxiugong.png'
import person10 from  './static/10quanmeitikefu.png'

import person1_1 from  './static/01anjianyuan2.png'
import person2_1 from  './static/02zhanwuyuan2.png'
import person3_1 from  './static/03liechesiji2.png'
import person4_1 from  './static/04baojieyuan2.png'
import person5_1 from  './static/05cheliangjianxiugong2.png'
import person6_1 from  './static/06jiechuwanggong2.png'
import person7_1 from  './static/07AFCjianxiugong2.png'
import person8_1 from  './static/08diaoduzhongxinpiaowu2.png'
import person9_1 from  './static/09tonghaojianxiugong2.png'
import person10_1 from  './static/10quanmeitikefu2.png'

// import personbox_01 from  './static/01a.png'
// import personbox_02 from  './static/02a.png'
// import personbox_03 from  './static/03a.png'
// import personbox_04 from  './static/04a.png'
// import personbox_05 from  './static/05a.png'
// import personbox_06 from  './static/06a.png'
// import personbox_07 from  './static/07a.png'
// import personbox_08 from  './static/08a.png'
// import personbox_09 from  './static/09a.png'
// import personbox_10 from  './static/10a.png'

import personbox2_01 from  './static/01b.png'
import personbox2_02 from  './static/02b.png'
import personbox2_03 from  './static/03b.png'
import personbox2_04 from  './static/04b.png'
import personbox2_05 from  './static/05b.png'
import personbox2_06 from  './static/06b.png'
import personbox2_07 from  './static/07b.png'
import personbox2_08 from  './static/08b.png'
import personbox2_09 from  './static/09b.png'
import personbox2_10 from  './static/10b.png'

import talk_01 from './static/talk_01.png'
import talk_02 from './static/talk_02.png'
import talk_03 from './static/talk_03.png'

import return_button from './static/return.png'
import miehuoqi from './static/miehuoqi.png'
import map from './static/map.png'

import tap_01_img01 from './static/tap_01_img01.png'
import tap_01_img02 from './static/tap_01_img02.png'
import tap_01_img03 from './static/tap_01_img03.png'
import tap_01_img04 from './static/tap_01_img04.png'
import tap_01_img05 from './static/tap_01_img05.png'

import tap_03_img01 from './static/tap_03_img01.png'

import tap_04_img01 from './static/tap_04_img01.png'
import tap_04_img02 from './static/tap_04_img02.png'
import tap_04_img04 from './static/tap_04_img04.png'
import tap_04_img06 from './static/tap_04_img06.png'
import tap_04_img07 from './static/tap_04_img07.png'
import tap_04_img09 from './static/tap_04_img09.png'


import tap_06_img01 from './static/tap_06_img01.png'
import tap_06_img02 from './static/tap_06_img02.png'

import tap_07_img from './static/tap_07_img.png'

import tap_07_img01 from './static/tap_07_img01.png'
import tap_07_img02 from './static/tap_07_img02.png'
import tap_07_img03 from './static/tap_07_img03.png'
import tap_07_img04 from './static/tap_07_img04.png'
import tap_07_img05 from './static/tap_07_img05.png'
import tap_07_img06 from './static/tap_07_img06.png'

import tap_08_img from './static/tap_08_img.png'

import tap_09_img01 from './static/tap_09_img01.png'

import tap_10_img from './static/tap_10_img.png'

import tap_stop_img from './static/tap_stop_img.png'

import tap_button1_img from './static/tap_button1_img.png'
import tap_button2_img from './static/tap_button2_img.png'
import tap_button3_img from './static/tap_button3_img.png'

import share_bg from './static/share_bg.png'
import share_icon1 from './static/share_icon1.png'
import share_icon2 from './static/share_icon2.png'
import share_person1 from './static/share_person1.png'
import share_person2 from './static/share_person2.png'
import share_person3 from './static/share_person3.png'
import share_person4 from './static/share_person4.png'
import share_person5 from './static/share_person5.png'
import share_person6 from './static/share_person6.png'
import share_person7 from './static/share_person7.png'
import share_person8 from './static/share_person8.png'
import share_person9 from './static/share_person8.png'
import share_person10 from './static/share_person10.png'

import share_button from './static/share_button.png'

import mp3_0 from './static/mp3/0.mp3'

import music from './static/music.png'

import keyMap from './static/keyMap.png'

import egg from './static/egg.png'
import click from './static/click.png'
import get from './static/get.png'

import car_button_01 from './static/car_button_01.png'
import car_button_02 from './static/car_button_02.png'
import car_button_03 from './static/car_button_03.png'
import car_button_04 from './static/car_button_04.png'

// const mp3 = [ mp3_0 , mp3_1 , mp3_2 , mp3_6 ]


class LoadingPage extends React.Component{

    images = [
        click,
        egg,
        keyMap,
        // music,
        tap_03_img01,
        get,
    
        index_bg2,

        car_button_01,
        car_button_02,
        car_button_03,
        car_button_04,
        // logo,
    
        main_01,
        main_02,
        main_03,
        main_04,
        main_05,
        main_06,
        main_07,
    
        person1,
        person2,
        person3,
        person4,
        person5,
        person6,
        person7,
        person8,
        person9,
        person10,
    
        // personbox_01,
        // personbox_02,
        // personbox_03,
        // personbox_04,
        // personbox_05,
        // personbox_06,
        // personbox_07,
        // personbox_08,
        // personbox_09,
        // personbox_10,

        person1_1,
        person2_1,
        person3_1,
        person4_1,
        person5_1,
        person6_1,
        person7_1,
        person8_1,
        person9_1,
        person10_1,
    
        personbox2_01,
        personbox2_02,
        personbox2_03,
        personbox2_04,
        personbox2_05,
        personbox2_06,
        personbox2_07,
        personbox2_08,
        personbox2_09,
        personbox2_10,
    
        // talk_01,
        // talk_02,
        // talk_03,
    
        tap_01_img01,
        tap_01_img02,
        tap_01_img03,
        tap_01_img04,
        tap_01_img05,
    
        tap_04_img01,
        tap_04_img02,
        tap_04_img04,
        tap_04_img06,
        tap_04_img07,
        tap_04_img09,
    
        tap_06_img01,
        tap_06_img02,
    
        tap_07_img,
        tap_07_img01,
        tap_07_img02,
        tap_07_img03,
        tap_07_img04,
        tap_07_img05,
        tap_07_img06,

        tap_08_img,
        tap_09_img01,
        tap_10_img,
    
        tap_stop_img,
        tap_button1_img,
        tap_button2_img,
        tap_button3_img,
        
        return_button,
        miehuoqi,
        map,
    
        share_bg,
        share_icon1,
        share_icon2,
        share_button,
    
        share_person1,
        share_person2,
        share_person3,
        share_person4,
        share_person5,
        share_person6,
        share_person7,
        share_person8,
        share_person9,
        share_person10,
    
    ]

    state={
        length: this.images.length,
        currentNum: 0,
    }

    componentDidMount(){
        this.setState({ length : this.images.length })
        this.handleComplete()
    }

    handleComplete = (data)=>{
        let num = 0
        this.images.forEach(item=>{
            this.getPreloadImgAttr(item,(value)=>{
                   value && num++
                   this.setState({ currentNum : num },()=>this.count(num))
            })
        })
        
    }

    count = (num)=>{
        const { from } = { from : { pathname: '/index' } }
        if(num === this.state.length){
            this.props.history.replace(from)
        }
    }

    getPreloadImgAttr = (url,callback) => {
        var oImg = new Image(); //创建一个Image对象,实现图片的预加载
        oImg.src = url;　       // 看下一节,其实应当先进行onload的绑定,再赋值给src
        if(oImg.complete){      //如果图片已经存在于浏览器缓存,直接调用回调函数
            callback.call(oImg);
            return;             //直接返回,不再处理onload事件
        }
        oImg.onload =()=>{      //图片下载完毕时异步调用callback函数
            oImg.onload = null;
            callback(oImg);   
        };
    }

    getlateXValue = (flag)=> {
        // 2680  1240
        const rotate = 1240 / window.reSizeH
        const width =  Number.parseFloat( (2680 / rotate).toFixed(2) )
        if(flag){
            return  `translateX(-${ (width - window.reSizeW) / 2 }px)`
        } else {
            return  width
        }
    } 

    render(){

        const { currentNum , length } = this.state

        const value = Number.parseInt(currentNum / length * 100) 

        return (

            <section className="loadContent">

                <audio src={mp3_0} preload="auto" />

                <img src={logo} className="logo" alt=""/>

                <img src={loading_bg001} className="loading_bg001" style={{width:this.getlateXValue(false) ,height:'100%' , transform: this.getlateXValue(true)}} alt=""/>

                <div className="f16">努力加载，请耐心等待({`${ value }%`})...</div>

            </section>

        )

    }

}

export default LoadingPage;